"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaVerifyToJSON = exports.MfaVerifyFromJSONTyped = exports.MfaVerifyFromJSON = void 0;
function MfaVerifyFromJSON(json) {
    return MfaVerifyFromJSONTyped(json, false);
}
exports.MfaVerifyFromJSON = MfaVerifyFromJSON;
function MfaVerifyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
        'pass': json['pass'],
    };
}
exports.MfaVerifyFromJSONTyped = MfaVerifyFromJSONTyped;
function MfaVerifyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
        'pass': value.pass,
    };
}
exports.MfaVerifyToJSON = MfaVerifyToJSON;
//# sourceMappingURL=MfaVerify.js.map